import { useMutation } from 'react-query';

import { runQsraAnalysis as mutationFn } from 'api/endPoints/runQsraAnalysis';

export const useMutationRunQsraAnalysis = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    numOfSimulations: number;
    riskIds: number[];
    metaDataId: number;
    taskVersionHashCode: string;
}
